import {
  ISelectItem,
  ModalContainerService,
} from "@aecom/core";
import { Component, HostListener, OnInit, inject } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  ICorrDocumentDownload,
  ICorrListItem,
} from "@api";
import { AuthService, BBJSelectUserService } from "@bbj/components";
import CorrespondenceRole from "@models/CorrespondenceRole";
import CorrIssue from "@models/corrIssue";
import CorrWithdrawStep from "@models/corrWithdrawStep";
import IViewPrepare from "@models/IViewPrepaer";
import BaseFunctionService from "@services/baseFunction.service";
import LoadingService from "@services/loading.service";
import LocalContractUserService from "@services/local-contractUser.service";
import LocalCorrespondenceTypeService from "@services/local-correspondenceType.service";
import {
  convertDateToUTCIOSString,
  getDateWithOffSet,
} from "@shared/utils";
import { WithdrawModalComponent } from "@shared/withdraw-modal/withdraw-modal.component";
import _ from "lodash";
import { Observable } from "rxjs";

@Component({
  selector: "app-issued",
  templateUrl: "./issued.component.html",
  styleUrls: ["./issued.component.scss"],
  standalone: false
})
export default class IssuedComponent implements OnInit {
  router = inject(Router);
  authService = inject(AuthService);
  activatedRoute = inject(ActivatedRoute);
  loadingService = inject(LoadingService);
  localContractUserService = inject(LocalContractUserService);
  localCorrespondenceTypeService = inject(LocalCorrespondenceTypeService);
  activeModal = inject(ModalContainerService);
  baseFunctionService = inject(BaseFunctionService);
  bbjSelectUserService = inject(BBJSelectUserService);

  @HostListener("window:beforeunload")
  canDeactivate(): Observable<boolean> | boolean {
    return !this.hasChanges();
  }

  entity: ICorrListItem;

  currentUser: string;

  defaultTab = "details";

  docs: ICorrDocumentDownload[] = [];

  isDbAdmin = false;

  corr: CorrIssue;

  oldCorr: CorrIssue;

  managersList: ISelectItem[] = [];

  corrTypeList: ISelectItem[] = [];

  canIssue = false;

  dueDate: Date | null = null;

  receivedDate: Date | null = null;

  today: Date;

  allTags: string[] = ["Apple", "Lemon", "Lime", "Orange", "Strawberry"];

  enableSaveDraft = false;

  userSelectTitle = "cc";

  ngOnInit(): void {
    const data: IViewPrepare | undefined =
      this.activatedRoute.snapshot.data.itemData;
    this.currentUser = this.authService.getUserId();
    this.today = new Date();
    if (data) {
      const { item, documents, topics } = data;
      this.entity = item;
      this.docs = documents;
      this.allTags = topics;
      this.oldCorr = new CorrIssue(this.entity.ContractId, this.entity);
      this.dueDate = this.oldCorr.correspondence_issued.DueDate
        ? new Date(
            getDateWithOffSet(this.oldCorr.correspondence_issued.DueDate),
          )
        : null;
      this.receivedDate = this.oldCorr.correspondence_issued.ReceivedDate
        ? new Date(
            getDateWithOffSet(this.oldCorr.correspondence_issued.ReceivedDate),
          )
        : null;
      this.managersList = this.localContractUserService.getUsersDropDownByRoleIds(false,[CorrespondenceRole.Manager]);
      this.corrTypeList = this.localCorrespondenceTypeService
        .getItems()
        .filter((u) => {
          return u.InActive !== true;
        })
        .sort((a, b) => (a.Title > b.Title ? 1 : -1))
        .map((u) => {
          return {
            id: u.Guid,
            name: u.Title,
            checked: false,
          };
        });
      console.log(this.managersList);
      this.baseFunctionService.initCCUsers(this.userSelectTitle);
    }

    this.corr = JSON.parse(JSON.stringify(this.oldCorr));
  }

  hasChanges(): boolean {
    const old = JSON.stringify(this.oldCorr);
    const current = JSON.stringify(this.corr);
    return old !== current || this.bbjSelectUserService.hasChanges();
  }

  back(): void {
    if (this.hasChanges()) {
      this.baseFunctionService.backAfterConfirm();
    } else {
      this.baseFunctionService.back();
    }
  }

  IsValid(): boolean {
    return !_.isEmpty(this.corr.correspondence_issued.ManagerId);
  }

  submit(): void {
    this.canIssue = true;

    this.corr.correspondence_issued.IsDraft = false;
    this.update();
  }

  save(): void {
    this.canIssue = true;

    this.corr.correspondence_issued.IsDraft = true;
    this.update();
  }

  update(): void {
    this.loadingService.start();
    if (this.corr.correspondence_issued.ReceivedToday) {
      this.corr.correspondence_issued.ReceivedDate = null;
    }
    if (!this.corr.correspondence_issued.RequireResponse) {
      this.corr.correspondence_issued.DueDate = null;
    }
    if (
      this.corr.correspondence_issued.CorrespondenceTypeId &&
      this.corr.correspondence_issued.CorrespondenceTypeId.trim() === ""
    ) {
      this.corr.correspondence_issued.CorrespondenceTypeId = null;
    }
    this.corr.correspondence_cc_user = this.bbjSelectUserService.getSelectedUserIds(this.userSelectTitle);
    console.log(this.corr);

    this.baseFunctionService.update(this.corr);
  }

  setRequireResponse(e: boolean): void {
    this.corr.correspondence_issued.RequireResponse = e;
    
  }

  setReceivedToday(e: boolean): void {
    this.corr.correspondence_issued.ReceivedToday = e;
    
  }

  setManager(e: ISelectItem): void {
    if (e && !Array.isArray(e)) {
      this.corr.correspondence_issued.ManagerId = e?.id;
    }
  }

  setCorrType(e: ISelectItem): void {
    if (e && !Array.isArray(e) && !("type" in e)) {
      console.log(e);
      this.corr.correspondence_issued.CorrespondenceTypeId = e?.id;
      
    }
  }

  setDate(e: Date | any): void {
    if (_.isNil(e) || e.type === "change") return;
    if (e.target?.value === "") {
      this.dueDate = null;
      this.corr.correspondence_issued.DueDate = null;
    } else {
      this.dueDate = new Date(e);
      this.corr.correspondence_issued.DueDate = convertDateToUTCIOSString(
        this.dueDate,
      );
    }
    
  }

  setReceivedDate(e: Date | any): void {
    if (_.isNil(e) || e.type === "change") return;
    if (e.target?.value === "") {
      this.receivedDate = null;
      this.corr.correspondence_issued.ReceivedDate = null;
    } else {
      this.receivedDate = new Date(e);
      this.corr.correspondence_issued.ReceivedDate = convertDateToUTCIOSString(
        this.receivedDate,
      );
    }
    
  }

  setIsConfidential(e: boolean): void {
    this.corr.correspondence_issued.IsConfidential = e;
    
  }

  withdraw(): void {
    const item = new CorrWithdrawStep(this.entity.ContractId, this.entity);
    const modalInstance = this.activeModal.open(WithdrawModalComponent);
    modalInstance.instance.setItem = item;
    modalInstance.result.then((result) => {
      if (result) {
        console.log(result);
        this.loadingService.start();
        this.baseFunctionService.update(item);
      }
    });
  }
}
